import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RecapContainer from '../../containers/recapContainer';

const propTypes = {
  accessible: PropTypes.string,
  nextFunc: PropTypes.func
};

class AltTextRecap extends Component {
  renderPause() {
    return (
      <div>
        <p className='pbs'>
          Did you notice the images in the email fade away? You're now looking at a representation of what a blind or low-vision person using a screen reader would hear.
        </p>
        <p className='pbs'>
          Check out the screen of the person across from you. What's different about the images?
        </p>
      </div>
      )
  }

  renderRecap() {
    return (
      <div>
        <p>
          Add a brief text description to image HTML or immediately
          below an image to communicate its meaning to screen reader users.
        </p>
      </div>
    )
  }

  render() {
    return (
      <RecapContainer
      	title='Alternative Text for Images'
      	nextLabel='Continue to Step 2'
      	nextFunc={this.props.nextFunc}
        pause={this.renderPause()}
        recap={this.renderRecap()}
      />
    );
  }
}

AltTextRecap.propTypes = propTypes;
export default AltTextRecap;




// WEBPACK FOOTER //
// ./src/steps/altText/recap.js